"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SecondaryButton = void 0;
const ui_1 = require("@completeanatomy/ui");
const styled_components_1 = __importDefault(require("styled-components"));
exports.SecondaryButton = (0, styled_components_1.default)(ui_1.BaseButton) `
  flex-shrink: 0;

  width: 160px;
  margin: 0 auto;
  padding: 12px 0;

  color: ${props => props.disabled ? props.theme.white : props.theme.greenSecondary};

  font-size: 14px;

  background: ${props => props.disabled ? props.theme.disabledSecondary : 'none'};

  border: 1px solid
    ${props => props.disabled
    ? props.theme.disabledSecondary
    : props.theme.greenSecondary};
  border-radius: 2px;
`;
